var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 64,
    viewBox: "0 0 240 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect3778",
    height: 64,
    width: 240,
    y: 0,
    x: -0.2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g4145",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3038-8",
    strokeWidth: 1.0095,
    d: "M 17.3 6.9 c -13.9 8 -18.6 25.7 -10.6 39.6 c 8 13.9 25.7 18.6 39.6 10.6 c 13.9 -8 18.6 -25.7 10.6 -39.6 c -8 -13.9 -25.7 -18.6 -39.6 -10.6 z m 1.7 3 c 12.2 -7.1 27.9 -2.9 34.9 9.4 c 7.1 12.2 2.9 27.9 -9.4 34.9 c -12.2 7.1 -27.9 2.9 -34.9 -9.4 c -7.1 -12.2 -2.9 -27.9 9.4 -34.9 z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1,0,0,-0.1,0,185)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0.4,0,0,0.3,852.4,-204.9)",
    d: "M -1709.3 6780.9 c 0 -10 59 -184 140 -412 c 93 -262 239 -683 340 -980 c 31 -92 29 -90 75 -90 c 37 0 44 3 53 28 c 11 28 115 328 137 397 c 8 22 49 144 93 270 c 71 205 107 307 236 670 c 20 55 36 106 36 113 c 0 7 -15 12 -40 12 c -22 0 -40 -1 -40 -3 c 0 -2 -36 -109 -81 -237 c -44 -129 -102 -300 -129 -380 c -28 -80 -84 -237 -125 -350 c -42 -113 -84 -230 -95 -260 c -32 -95 -48 -126 -54 -110 c -3 8 -18 53 -34 100 c -16 47 -59 166 -95 265 c -86 238 -99 275 -157 445 c -27 80 -78 230 -114 334 c -36 104 -66 191 -66 193 c 0 1 -18 3 -40 3 c -22 0 -40 -4 -40 -8 z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.1,0,0,-0.1,0,185)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0.4,0,0,0.3,803.5,305.9)",
    d: "M -1422.7 4455.5 c -25 -72 -150 -437 -181 -528 c -7 -22 -30 -85 -50 -140 c -20 -55 -58 -165 -84 -245 c -27 -80 -67 -197 -90 -260 c -38 -103 -71 -200 -71 -208 c 0 -2 17 -2 37 0 l 37 3 l 41 120 c 23 66 56 161 73 210 c 18 50 75 216 127 370 c 53 154 121 355 153 448 c 31 92 61 167 67 167 c 12 0 20 -17 79 -190 c 26 -74 62 -175 81 -225 c 19 -49 68 -191 109 -315 c 41 -124 92 -274 114 -335 c 22 -60 51 -139 64 -175 c 18 -52 28 -66 46 -68 c 60 -9 61 -14 -59 318 c -11 30 -38 109 -59 175 c -22 66 -80 234 -130 373 c -49 139 -90 257 -90 263 c 0 8 -73 219 -102 292 c -9 23 -16 27 -48 27 l -37 0 l -27 -77 z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logotext",
    "aria-label": "VNavi",
    transform: "matrix(0.1,0,0,-0.1,0,50)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0.3,0,0,0.3,749.8,169.3)",
    d: "M -26.6 659.7 c 0 -4 359 -813 402 -906 c 17 -36 31 -69 33 -75 c 1 -5 14 -37 30 -70 c 79 -172 95 -208 95 -216 c 0 -6 23 -9 52 -7 l 51 3 l 277 621 c 152 342 280 629 283 638 c 5 13 -1 16 -41 16 l -48 0 l -258 -580 c -143 -320 -262 -577 -266 -573 c -4 4 -20 40 -35 78 c -16 39 -32 75 -36 80 c -6 9 -150 331 -291 650 c -22 50 -54 122 -72 160 c -18 39 -43 96 -57 127 l -24 58 l -47 0 c -27 0 -48 -2 -48 -4 z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0.3,0,0,0.3,1117.5,169.2)",
    d: "M 162.4 24.2 l 0 -640 l 45 0 l 45 0 l 0 551 c 0 316 4 549 9 547 c 5 -1 201 -248 436 -548 c 425 -543 427 -545 466 -548 l 39 -3 l 0 640 l 0 641 l -45 0 l -45 0 l -2 -556 l -3 -557 l -435 557 l -435 556 l -37 0 l -38 0 l 0 -640 z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0.3,0,0,0.3,1498.4,169.5)",
    d: "M 727.3 641.3 c -5 -13 -29 -66 -54 -118 c -81 -175 -94 -203 -310 -673 l -215 -467 l 48 0 l 48 0 l 82 183 c 46 100 93 205 106 232 c 13 28 93 205 179 395 c 86 190 159 348 164 353 c 4 4 126 -252 271 -570 c 144 -318 265 -582 270 -586 c 4 -5 27 -7 52 -5 l 45 3 l -292 635 l -292 635 l -46 3 c -41 3 -48 0 -56 -20 z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0.3,0,0,0.3,1829.1,169.2)",
    d: "M 292.8 572.2 c 23 -51 150 -338 284 -638 l 243 -545 l 48 -3 l 48 -3 l 154 348 c 85 191 171 384 191 428 c 58 126 220 494 220 500 c 0 4 -21 5 -47 3 l -46 -3 l -254 -570 c -140 -314 -257 -573 -261 -577 c -4 -4 -45 77 -91 180 c -45 103 -162 364 -258 580 l -175 392 l -49 0 l -48 0 l 41 -92 z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0.3,0,0,0.3,2067.3,170.1)",
    d: "M 885.3 648.8 c -3 -7 -4 -294 -3 -638 l 3 -625 l 42 -3 l 43 -3 l 2 624 c 2 343 2 631 0 640 c -4 21 -80 24 -87 5 z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5df06ac1321e15f5033a80e4292302ea.svg";
export { ForwardRef as ReactComponent };